import axios from "axios";

export function debugEnabled() {
  return localStorage.getItem("debug:logLevel") === "debug";
}

export function logAxiosErrorIfDebug(error, context = {}) {
  const status = error?.response?.status;
  const url = error?.config?.url;
  const method = error?.config?.method;
  const code = error?.code;

  // Konsoliin vain kun debug-lippu on paalla
  if (debugEnabled()) {
    console.error("[HTTP ERROR]", error);
    console.error("[HTTP DETAILS]", {
      ...context,
      status,
      code,
      method,
      url,
      responseData: error?.response?.data,
    });
    if (error?.stack) console.error("[STACK]", error.stack);
  }

  // Bakkarille aina - tallennetaan tiedostoon riippumatta debug-lipusta (fire-and-forget)
  axios
    .post("/1.0/front/clientlog", {
      level: "error",
      ...context,
      status,
      code,
      method,
      url,
      message: error?.message,
      responseData: error?.response?.data,
      stack: error?.stack,
    })
    .catch(() => {
      // Hiljaa - ei rekursiivista logitusta jos bakkari on alhaalla
    });
}
